import { withErrorBoundary } from "@sentry/nextjs";
import { VFC } from "react";
import styled from "styled-components";
import { Close } from "icons";

interface Props {
  className?: string;
  onClick: () => void;
}

const CloseButton: VFC<Props> = withErrorBoundary(({ className = "", onClick }) => {
  return (
    <StyledCloseButton className={className} onClick={onClick}>
      <Close className="CloseButton__icon" />
    </StyledCloseButton>
  );
}, {});

const StyledCloseButton = styled.button`
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;

  .CloseButton__icon {
    width: 16px;
    height: 16px;
    fill: ${({ theme }) => theme.colors.fog["60"]};
  }
`;

export { CloseButton };
